import React, { useEffect, useState } from "react";
import { Star, Sparkles, Tag } from "lucide-react";
import "./CourseCard.css";
import { courseApi } from "../../../../api/api";
import api from "../../../../utils/api";
import { Link, useNavigate } from "react-router-dom";

export default function CourseCard() {

    const [courses, setCourses] = useState([]);

    useEffect(() => {
        async function fetchCourses() {
            try {
                const response = await api.get(courseApi);
                setCourses(response.data);
            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        }
        fetchCourses();
    }, []);


    return (
        <div className="course-card-container">
            {courses
                .filter((course) => course.status === 1 || course.status === true)
                .map((course, idx) => (
                    <div className="course-card-item" key={idx}>
                        <div className="course-card-image-wrapper">
                            <img
                                src={course.image}
                                alt={course.title}
                                className="course-card-image"
                            />
                            {course.isPopular && (
                                <span className="course-card-badge popular">
                                    <Star size={14} /> Popular
                                </span>
                            )}
                            {course.isNew && (
                                <span className="course-card-badge new">
                                    <Sparkles size={14} /> New
                                </span>
                            )}
                        </div>
                        <div className="course-card-content">
                            <h3 className="course-card-title">{course.title}</h3>
                            <p className="course-card-description">{course.description}</p>
                            <div className="course-card-footer">
                                {/* <span className="course-card-price">
                                <Tag size={14} /> ₹{course.price}
                            </span> */}
                                <Link to={`/course/course-page/${course.id}`}>
                                    <button className="primary-button">View Details</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    );
}
